export const GET_ACCESSIBILITY_DETAILS_SUCCESS =
  "GET_ACCESSIBILITY_DETAILS_SUCCESS";
export const GET_ACCESSIBILITY_DETAILS_LOADING =
  "GET_ACCESSIBILITY_DETAILS_LOADING";
export const GET_ACCESSIBILITY_DETAILS_FAILED =
  "GET_ACCESSIBILITY_DETAILS_FAILED";
export const RESET_ACCESSIBILITY_DETAILS = "RESET_ACCESSIBILITY_DETAILS";
